<template>
  <div class="bookings-pages-cont">
    <pagination
      placement="top"
      v-if="booking_details.page > 0"
      v-model="booking_details.page"
      :records="booking_details.total_items"
      :per-page="booking_details.items_per_page"
      @paginate="
        $emit('load-page', {
          page: booking_details.page,
          list_type: booking_list_type
        })
      "
      :options="pagination_options"
    />
    <div
      class="empty-booking-cont"
      v-if="booking_details.bookings.length == 0 && booking_details.eol"
    >
      <span
        v-if="
          booking_list_type == 'upcoming' &&
            filter_options.booking_status == '1' &&
            filter_options.admin_user_id ==
              $store.getters.get_current_admin_details.id
        "
        >{{ T__("You have no Upcoming bookings.") }}
        {{ T__("Time to chill...") }}</span
      >
      <span
        v-if="
          booking_list_type == 'past' &&
            filter_options.booking_status == '1' &&
            filter_options.admin_user_id ==
              $store.getters.get_current_admin_details.id
        "
        >{{ T__("There are no past bookings.") }}</span
      >
      <span
        v-else-if="
          booking_list_type == 'upcoming' || booking_list_type == 'past'
        "
        >{{ T__("No matching bookings found.") }}</span
      >
      <span v-if="booking_list_type == 'custom'">{{
        T__("No matching bookings found. Try changing the filters above.")
      }}</span>
    </div>
    <div class="all-days-cont">
      <div
        class="day-cont"
        v-for="(date_grouped_bookings, index) in booking_details_for_view"
        :key="index"
      >
        <div class="date-cont">
          {{
            date_grouped_bookings.group_date | wpcal_unix_to_sw_sm_sd_if_fy(tz)
          }}<br /><span>{{
            date_grouped_bookings.group_date | wpcal_unix_to_relative_day(tz)
          }}</span>
        </div>
        <div class="events-cont">
          <div
            class="single-event-cont"
            :class="{
              expanded: is_booking_expanded(booking.id),
              ['clr-' + booking.service_details.color]: true
            }"
            v-for="(booking, index2) in date_grouped_bookings.bookings"
            :key="index2"
          >
            <div class="event-summary">
              <div class="event-slot">
                <div
                  :class="{
                    disabled: booking.status == -1 || booking.status == -5
                  }"
                >
                  <span
                    :title="
                      $options.filters.wpcal_unix_to_time(
                        booking.booking_from_time,
                        tz,
                        time_format
                      ) +
                        ' ' +
                        $options.filters.wpcal_unix_to_sw_sm_sd_if_fy(
                          booking.booking_from_time,
                          tz
                        )
                    "
                    >{{
                      booking.booking_from_time
                        | wpcal_unix_to_time(tz, time_format)
                    }}</span
                  >
                  -
                  <span
                    :title="
                      $options.filters.wpcal_unix_to_time(
                        booking.booking_to_time,
                        tz,
                        time_format
                      ) +
                        ' ' +
                        $options.filters.wpcal_unix_to_sw_sm_sd_if_fy(
                          booking.booking_to_time,
                          tz
                        )
                    "
                    >{{
                      booking.booking_to_time
                        | wpcal_unix_to_time(tz, time_format)
                    }}</span
                  >
                </div>
                <div
                  class="status-cancelled-rescheduled"
                  v-if="booking.status == -1 || booking.status == -5"
                >
                  {{
                    booking.status
                      | admin_booking_status(booking.booking_to_time)
                  }}
                </div>
              </div>
              <div class="event-invitee-type">
                <span
                  v-html="
                    Tsprintf(
                      /* translators: 1: html-tag-open 2: html-tag-close 3: invitee name */
                      T__('%1$s %3$s %2$s with %4$s.'),
                      '<strong>',
                      '</strong>',
                      booking.invitee_name,
                      select_admin_name(booking)
                    )
                  "
                ></span
                ><br />
                {{ T__("Event Type:") }}
                <strong>{{ booking.service_details.name }}</strong>
              </div>
              <div class="show-link">
                <a @click="toggle_expand_booking(booking.id)">
                  {{ T__("DETAILS") }}</a
                ><br /><span
                  class="created-date"
                  :title="
                    $options.filters.wpcal_unix_to_time(booking.added_ts, tz) +
                      ' ' +
                      $options.filters.wpcal_unix_to_full_date_day(
                        booking.added_ts,
                        tz
                      )
                  "
                  >{{ T__("created") }}
                  {{ booking.added_ts | wpcal_unix_to_sm_sd_if_fy(tz) }}</span
                >
              </div>
            </div>
            <div class="event-detailed">
              <div class="actions-cont">
                <div
                  v-if="
                    booking.status == 1 && booking.booking_to_time > cutoff_time
                  "
                >
                  <a
                    class="btn reschedule"
                    @click="show_service_booking_modal(booking)"
                    >{{ T__("Reschedule") }}</a
                  >
                  <a
                    class="btn cancel"
                    @click="show_cancel_confirmation(booking)"
                    >{{ T__("Cancel") }}</a
                  >
                </div>
                <a
                  :href="'#/event-type/edit/' + booking.service_id"
                  target="_blank"
                  >{{ T__("Edit Event Type") }}</a
                ><br />
                <a
                  @click="
                    show_service_booking_modal_for_schedule_invitee_again(
                      booking
                    )
                  "
                  >{{ T__("Schedule Invitee Again") }}</a
                >
              </div>
              <div class="event-meta">
                <div class="event-meta-invitee-details">
                  <div>
                    <div class="event-meta-label">{{ T__("NAME") }}</div>
                    {{ booking.invitee_name }}
                  </div>
                  <div>
                    <div class="event-meta-label">{{ T__("EMAIL") }}</div>
                    {{ booking.invitee_email }}
                  </div>
                  <div style="padding-right: 10px; box-sizing: border-box;">
                    <div class="event-meta-label">{{ T__("LOCATION") }}</div>
                    <LocationAdvanced
                      type="display_user_after_booking_location"
                      :location_details="booking.location"
                      :booking_details="booking"
                    />
                  </div>
                  <div>
                    <div class="event-meta-label">
                      {{ T__("INVITEE TIME ZONE") }}
                    </div>
                    {{ booking.invitee_tz | wpcal_format_tz }}
                  </div>
                </div>
                <div
                  class="cancel-reschedule-reason-cont"
                  v-if="booking.status == -1 || booking.status == -5"
                >
                  <div>
                    <div class="event-meta-label">
                      {{
                        get_action_label(booking.status, "verb") +
                          " " +
                          "Reason"
                      }}
                    </div>
                    <div style="white-space: pre-line;">
                      {{
                        booking.reschedule_cancel_reason
                          ? booking.reschedule_cancel_reason
                          : "(Not entered)"
                      }}
                    </div>
                  </div>
                  <div>
                    <div class="event-meta-label">
                      {{
                        get_action_label(booking.status, "past") + " " + "by"
                      }}
                    </div>
                    {{
                      booking.reschedule_cancel_user_full_name
                        ? booking.reschedule_cancel_user_full_name
                        : "N/A"
                    }}
                  </div>
                  <div>
                    <div class="event-meta-label">
                      {{
                        get_action_label(booking.status, "past") + " " + "at"
                      }}
                    </div>
                    {{
                      booking.reschedule_cancel_action_ts
                        | wpcal_unix_to_time(tz)
                    }}
                    {{
                      booking.reschedule_cancel_action_ts
                        | wpcal_unix_to_full_date_day(tz)
                    }}
                  </div>
                  <div
                    v-if="
                      booking.status == -5 && booking.rescheduled_booking_id
                    "
                  >
                    <router-link
                      :to="'/bookings/custom/' + booking.rescheduled_booking_id"
                      >{{ T__("View new booking") }}</router-link
                    >
                  </div>
                </div>
              </div>

              <div class="event-survey">
                <div
                  class="wpc-form-row"
                  v-for="(question, index) in booking.invitee_question_answers"
                  :key="index"
                >
                  <div
                    class="txt-h5 pre"
                    style="color: #7c7d9c; margin-bottom:5px;"
                  >
                    {{ question.question }}
                  </div>
                  <div
                    class="pre"
                    v-if="question.answer == ''"
                    style="margin-bottom:10px; font-size:13px; font-style: italic;"
                  >
                    (Not entered)
                  </div>
                  <div class="pre b" v-else style="margin-bottom:10px;">
                    {{ question.answer }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
        style="width:100%;text-align:center;cursor:pointer;"
        @click="$emit('load-more', booking_list_type)"
        v-if="booking_details.page > -1 && !booking_details.eol"
      >
        {{ T__("Load more") }}
      </div> -->
    <pagination
      placement="bottom"
      v-if="booking_details.page > 0"
      v-model="booking_details.page"
      :records="booking_details.total_items"
      :per-page="booking_details.items_per_page"
      @paginate="
        $emit('load-page', {
          page: booking_details.page,
          list_type: booking_list_type
        })
      "
      :options="pagination_options"
    />

    <!-- <v-dialog /> -->
    <modal
      name="service_booking_modal"
      width="1000px"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      style="z-index:9999;"
      @closed="reschedule_booking = {}"
    >
      <Booking
        v-if="reschedule_booking.hasOwnProperty('id')"
        admin_end_booking_type="reschedule"
        :admin_end_service_id="reschedule_booking.service_id"
        :admin_end_old_booking_unique_link="reschedule_booking.unique_link"
        @booking-rescheduled="handle_rescheduled_booking($event)"
      />
      <Booking
        v-else-if="schedule_invitee_again.hasOwnProperty('id')"
        admin_end_booking_type="new"
        :admin_end_service_id="schedule_invitee_again.service_id"
        :admin_end_old_booking_unique_link="schedule_invitee_again.unique_link"
        :admin_end_is_schedule_invitee_again="true"
        @booking-added="handle_schedule_invitee_again_booking($event)"
      />
    </modal>
    <BookingCancelModal
      v-if="booking_detail_for_cancel_modal"
      :booking_details="booking_detail_for_cancel_modal"
      :cancel_booking_btn_is_enabled="cancel_booking_btn_is_enabled"
      v-model="cancel_reason"
      @cancel-booking="cancel_booking($event)"
    />
  </div>
</template>

<script>
import Booking from "@/views/user/Booking.vue"; //user view is imported here
import LocationAdvanced from "@/components/LocationAdvanced.vue";
import BookingCancelModal from "@/components/BookingCancelModal.vue";

import Pagination from "@/components/form_elements/Pagination.vue";

import { findIndex as _findIndex, sortBy as _sortBy } from "lodash-es";

import axios from "axios";

export default {
  components: {
    Booking,
    LocationAdvanced,
    Pagination,
    BookingCancelModal
  },
  props: {
    booking_list_type: {
      type: String,
      required: true
    },
    booking_details: {
      type: Object
    },
    filter_options: {
      type: Object
    }
  },
  data() {
    return {
      expanded_bookings: [],
      reschedule_booking: {},
      schedule_invitee_again: {},
      cutoff_time: 0,
      action_strings: {
        "-1": {
          verb: "Cancellation",
          past: "Cancelled"
        },
        "-5": {
          verb: "Reschedule",
          past: "Rescheduled"
        }
      },
      pagination_options: {
        chunk: 10,
        chunksNavigation: "scroll",
        edgeNavigation: true,
        texts: {
          count: "{from} - {to} of {count}|{count} bookings|{count} booking"
        }
      },
      booking_detail_for_cancel_modal: null,
      cancel_reason: "",
      cancel_booking_btn_is_enabled: true
    };
  },
  computed: {
    // pagination_options() {
    //   return {
    //     chunk: 3,
    //     chunksNavigation: "scroll",
    //     edgeNavigation: true,
    //     texts: {
    //       count: this.pagination_count_text
    //     }
    //   };
    // },
    // pagination_count_text() {
    //   let str = "{from} - {to} of {count}";
    //   let count = this.booking_details.total_items
    //     ? this.booking_details.total_items
    //     : 0;
    //   let final_str = str.replace(/{count_}/g, count);
    //   return final_str;
    // },
    booking_details_for_view() {
      let __tmp = [];

      for (let booking of this.booking_details.bookings) {
        let new_date = this.$options.filters.wpcal_unix_to_unix_only_date(
          booking.booking_from_time,
          this.tz
        );

        let _index = _findIndex(__tmp, { group_date: new_date });
        if (_index == -1) {
          _index = __tmp.length;
          __tmp[_index] = { group_date: new_date, bookings: [] };
        }
        __tmp[_index]["bookings"].push(booking);
      }

      if (this.booking_list_type === "past") {
        for (let date_grouped_bookings of __tmp) {
          date_grouped_bookings.bookings = _sortBy(
            date_grouped_bookings.bookings,
            ["booking_from_time"]
          );
        }
      }

      return __tmp;
    }
  },
  methods: {
    is_booking_expanded(booking_id) {
      return this.expanded_bookings.indexOf(booking_id) !== -1;
    },
    toggle_expand_booking(booking_id) {
      if (this.is_booking_expanded(booking_id)) {
        let index = this.expanded_bookings.indexOf(booking_id);
        this.expanded_bookings.splice(index, 1);
      } else {
        this.expanded_bookings.push(booking_id);
      }
    },
    get_action_label(status, tense) {
      if (this.action_strings.hasOwnProperty(status)) {
        return this.action_strings[status]?.[tense];
      }
      return status;
    },
    select_admin_name(booking) {
      if (
        booking.admin_user_id ==
        this.$store.getters.get_current_admin_details.id
      ) {
        return "You";
      }
      return booking.admin_user_full_name;
    },
    show_cancel_confirmation(booking) {
      this.cancel_reason = "";
      this.booking_detail_for_cancel_modal = booking;
      this.$nextTick(() => {
        this.$modal.show("booking_cancel_confirm_modal");
      });
      // let dialog_text_from_to_time_str = this.$options.filters.wpcal_unix_to_from_to_time_full_date_day_tz(
      //   booking.booking_from_time,
      //   booking.booking_to_time,
      //   this.tz,
      //   this.time_format
      // );

      // let dialog_text = this.Tsprintf(
      //   /* translators: 1: html-tag 2: from and to date time 3: invitee name 4: email */
      //   this.T__(
      //     "Are you sure you want to Cancel this Booking? %1$s %1$s At %2$s %1$s with %3$s (%4$s)"
      //   ),
      //   "<br>",
      //   dialog_text_from_to_time_str,
      //   booking.invitee_name,
      //   booking.invitee_email
      // );

      // this.$modal.show("dialog", {
      //   title: this.T__("Alert!"),
      //   text: dialog_text,
      //   buttons: [
      //     {
      //       title: this.T__("Yes, Cancel the booking"),
      //       handler: () => {
      //         this.cancel_booking(booking);
      //         this.$modal.hide("dialog");
      //       }
      //     },
      //     {
      //       title: this.T__("No"),
      //       default: true // Will be triggered by default if 'Enter' pressed.
      //     }
      //   ]
      // });
    },
    cancel_booking(booking) {
      this.cancel_booking_btn_is_enabled = false;
      let wpcal_request = {};
      let action = "cancel_booking";

      wpcal_request[action] = {
        booking_id: booking.id,
        cancel_reason: this.cancel_reason
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(response.data[action], {
            success_msg: this.T__("Booking cancelled successfully.")
          });
          if (response.data[action].status == "success") {
            // below coded commented - Instead of removing the booking, lets reload the page
            // this.$emit("remove-booking", {
            //   booking_id: booking.id,
            //   booking_list_type: this.booking_list_type
            // });

            let wpcal_booking_trigger = new CustomEvent(
              "wpcal_booking_cancelled",
              {
                detail: {
                  booking_details: { unique_link: booking.unique_link }
                }
              }
            );
            document.dispatchEvent(wpcal_booking_trigger);

            this.$emit("load-page", {
              page: this.booking_details.page,
              list_type: this.booking_list_type
            });
            //this.$modal.hide("dialog");
            this.$modal.hide("booking_cancel_confirm_modal");
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.$store.dispatch("run_booking_background_tasks_by_unique_link", {
            unique_link: booking.unique_link
          });
          this.cancel_booking_btn_is_enabled = true;
        });
    },
    show_service_booking_modal(booking) {
      this.reschedule_booking = this.clone_deep(booking);
      this.$modal.show("service_booking_modal");
    },
    handle_rescheduled_booking(info) {
      this.reschedule_booking = {};
      // below coded commented - Instead of removing the booking, lets reload the page
      // this.$emit("remove-booking", {
      //   booking_unique_link: info.old_booking.unique_link,
      //   booking_list_type: this.booking_list_type
      // });
      this.$emit("load-page", {
        page: this.booking_details.page,
        list_type: this.booking_list_type
      });
      this.$modal.hide("service_booking_modal");
      this.show_rescheduled_information(info);
    },
    show_rescheduled_information(info) {
      let dialog_text = "";
      dialog_text += "<div>";
      dialog_text += this.T__("The booking has been successfully rescheduled.");
      if (info?.new_booking_id) {
        dialog_text +=
          ' <a href="#/bookings/custom/' +
          info.new_booking_id +
          '" target="_blank">View new booking</a>';
      }
      dialog_text += "</div>";

      // dialog_text +=
      //   '<div style="float:left;width:300px;word-wrap: break-word;">Old Booking' +
      //   JSON.stringify(info.old_booking) +
      //   "</div>";
      // dialog_text +=
      //   '<div style="float:left;width:300px;word-wrap: break-word;">New Booking' +
      //   JSON.stringify(info.new_booking) +
      //   "</div>";

      this.$modal.show("dialog", {
        title: this.T__("Booking rescheduled"),
        text: dialog_text,
        buttons: [
          {
            title: "Okay",
            default: true // Will be triggered by default if 'Enter' pressed.
          }
        ],
        width: "610px"
      });
    },
    show_service_booking_modal_for_schedule_invitee_again(booking) {
      this.schedule_invitee_again = this.clone_deep(booking);
      this.$modal.show("service_booking_modal");
    },
    handle_schedule_invitee_again_booking() {
      this.schedule_invitee_again = {};
      this.$modal.hide("service_booking_modal");
      this.$modal.show("dialog", {
        title: this.T__("Booking scheduled"),
        text: this.T__("The new booking has been successfully scheduled."),
        buttons: [
          {
            title: this.T__("Okay")
          }
        ]
      });
    }
  },
  beforeUpdate: function() {
    this.cutoff_time = Math.round(new Date().getTime() / 1000);
  }
};
</script>
<style scoped>
.empty-booking-cont {
  padding: 20px;
  text-align: center;
  font-size: 14px;
}
.event-slot .disabled {
  /* tmp dev code - Improve it */
  text-decoration: line-through;
}

.event-meta-label {
  color: #7c7d9c;
  font-size: 13px;
  text-transform: uppercase;
}
.event-slot .status-cancelled-rescheduled {
  background-color: #fdeced;
  border: 1px dashed #e84653;
  text-transform: uppercase;
  color: #e84653;
  font-size: 11px;
  display: inline-block;
  padding: 3px 5px;
  border-radius: 5px;
  margin-top: 5px;
}
.cancel-reschedule-reason-cont {
  border-top: 1px solid #b1b6d1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto auto;
  grid-gap: 20px;
  padding-top: 15px;
  margin-top: 15px;
}
.cancel-reschedule-reason-cont > div {
  flex: 1;
  word-break: break-word;
}
.cancel-reschedule-reason-cont > div:first-child {
  grid-column: 1 / -1;
}
</style>
